import { render, staticRenderFns } from "./m-addQuestionImageChild.vue?vue&type=template&id=1e4fcddf&"
import script from "./m-addQuestionImageChild.vue?vue&type=script&lang=js&"
export * from "./m-addQuestionImageChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports